import { useEffect, useRef, useState } from 'react';

export const useSize = <T extends HTMLElement | HTMLDivElement>() => {
  const ref = useRef<T>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver(([entry]) =>
      setSize({ width: entry.contentRect.width, height: entry.contentRect.height }),
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return [ref, size] as const;
};
